// 화면과 같은 글꼴로 텍스트의 픽셀 폭을 측정 (고정 레이아웃 표에서 열 폭을 데이터에 맞출 때 사용)
let ctx = null;
export function measureTextWidth(text, font) {
  if (!ctx) ctx = document.createElement('canvas').getContext('2d');
  ctx.font = font;
  return ctx.measureText(String(text)).width;
}
